import { ReactNode, SyntheticEvent } from 'react';
import { makeStyles } from 'tss-react/mui';

const useMediaActionStyles = makeStyles()((theme) => ({
  button: {
    color: theme.palette.action.active,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

type MediaActionButtonType = {
  children: ReactNode;
  onClick?: (evt: SyntheticEvent) => void;
  className?: string;
};

const MediaActionButton = ({ children, className, onClick }: MediaActionButtonType) => {
  const { classes, cx } = useMediaActionStyles();
  const handleClick = (event: SyntheticEvent) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <div className={cx(classes.button, className || 'ActionButton')} onClick={handleClick}>
      {children}
    </div>
  );
};

export default MediaActionButton;
